import { SxProps } from '@mui/material/styles';

export const TextCutWithDotsStyles: SxProps = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
